<rpfsa-user-header
	headerText="Customer Portal Users"
	class="mb-2"
></rpfsa-user-header>

<mat-card>
	<rpfsa-customer-user-list-filters
		[formControl]="filter"
	></rpfsa-customer-user-list-filters>

	<table
		mat-table
		class="list-container mb-3"
		[dataSource]="pagedCustomerUsers$ | async"
		matSort
		matSortActive="{{ sort.active }}"
		matSortDisableClear
		matSortDirection="{{ sort.direction }}"
	>
		<ng-container matColumnDef="empty">
			<th
				mat-header-cell
				*matHeaderCellDef
				[colSpan]="resultColumns.length"
				class="text-center"
			>
				<div *ngIf="isLoading$ | async" class="list-loader">
					<mat-progress-bar mode="indeterminate"></mat-progress-bar>
				</div>
				<em> {{ listMessage$ | async }}</em>
			</th>
		</ng-container>

		<ng-container matColumnDef="name">
			<th mat-header-cell *matHeaderCellDef>Name</th>
			<td mat-cell *matCellDef="let user">
				<a [routerLink]="usersFragments.customerUserDetail(user?.id)">
					{{ user.firstName }} {{ user.lastName }}
				</a>
			</td>
		</ng-container>
		<ng-container matColumnDef="email">
			<th mat-header-cell *matHeaderCellDef>Username</th>
			<td mat-cell *matCellDef="let user">{{ user.email }}</td>
		</ng-container>
		<ng-container matColumnDef="phoneNumber">
			<th mat-header-cell *matHeaderCellDef>Phone Number</th>
			<td mat-cell *matCellDef="let user">
				{{ user.phoneNumber }}
			</td>
		</ng-container>
		<ng-container matColumnDef="companyName">
			<th mat-header-cell *matHeaderCellDef>Customer</th>
			<td mat-cell *matCellDef="let user">
				<a
					*ngIf="user.customer; else notLinked"
					[routerLink]="customersFragments.detail(user.customer?.id)"
				>
					{{ user.customer?.companyName }}
				</a>
				<ng-template #notLinked>
					<small>
						<em>Not linked</em>
					</small>
				</ng-template>
			</td>
		</ng-container>
		<tr
			mat-header-row
			*matHeaderRowDef="resultColumns"
			[class.hidden]="listMessage$ | async"
		></tr>
		<tr
			mat-header-row
			*matHeaderRowDef="emptyColumns"
			[class.hidden]="!(listMessage$ | async)"
		></tr>
		<tr
			mat-row
			*matRowDef="let user; columns: resultColumns"
			[@animateList]
		></tr>
	</table>

	<div fxLayout fxLayoutAlign="space-between center">
		<mat-paginator [length]="pagedCustomerUsersCount$ | async">
		</mat-paginator>
	</div>
</mat-card>
